document.addEventListener("DOMContentLoaded", () => {
  const gstInput = document.getElementById("gstin_input");
  const btn = document.getElementById("gstin_fetch_btn");
  const errorEl = document.getElementById("gstin_error");

  if (!gstInput || !btn) return;

  btn.addEventListener("click", async () => {
    errorEl.style.display = "none";
    const raw = (gstInput.value || "").toUpperCase().trim();

    // Basic format check
    const validFormat = /^[0-9A-Z]{15}$/.test(raw);
    if (!validFormat) {
      errorEl.textContent = "Please enter a valid 15-character GSTIN.";
      errorEl.style.display = "block";
      return;
    }

    btn.disabled = true;
    const oldText = btn.textContent;
    btn.textContent = "Fetching...";

    try {
      // For now: call your backend on *this same PC*
      const response = await fetch(
        `http://localhost:4000/api/gstin-lookup?gstin=${encodeURIComponent(raw)}`
      );

      const result = await response.json();

      if (result.error) {
        throw new Error(result.message || "GSTIN not found or inactive.");
      }

      const data = result.data || {};

      document.getElementById("gst_legal_name").value = data.legalName || "";
      document.getElementById("gst_trade_name").value = data.tradeName || "";

      const addr = data.address || {};
      const addressParts = [
        addr.building,
        addr.street,
        addr.locality,
      ].filter(Boolean);

      document.getElementById("gst_address_line").value = addressParts.join(", ");
      document.getElementById("gst_city").value = addr.city || "";
      document.getElementById("gst_state").value = addr.state || "";
      document.getElementById("gst_pincode").value = addr.pincode || "";
      document.getElementById("gst_status").value = data.status || "";

    } catch (err) {
      console.error(err);
      errorEl.textContent = err.message || "Could not fetch GST details. Please try again.";
      errorEl.style.display = "block";
    } finally {
      btn.disabled = false;
      btn.textContent = oldText;
    }
  });
});